import { getFormattedProduct } from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackAddToWishlist = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackAddToWishlistEvent = useCallback(
    (product, isMoveToWishlist = false) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (product) {
          window.webengage.track(
            isMoveToWishlist ? "move_to_wishlist" : "add_to_wishlist",
            getFormattedProduct(product)
          );
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackAddToWishlistEvent };
};

export default useTrackAddToWishlist;
